import React from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import AuthProtected  from './AuthProtected';
import Error404 from 'pages/Error/Error404';
import OnboardingLayout from 'Layouts/OnboardingLayout';

const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected>
                                    {
                                        route.onboarding ? <OnboardingLayout>{route.component}</OnboardingLayout> : <VerticalLayout>{route.component}</VerticalLayout>
                                    }
                                </AuthProtected>}
                            key={idx}
                        />
                    ))}
                </Route>
                <Route path='*' element={<Error404 />} />
            </Routes>
        </React.Fragment>
    );
};

export default Index;